"use client";

import { motion } from "motion/react";

/**
 * Apple-style top gradient entrance.
 *
 *   - Four layered radial gradients (red, deep orange, warm orange,
 *     cool blue) are softly blurred into each other so the top of the
 *     page picks up a subtle, multi-hue wash.
 *   - On mount, the whole group fades + eases in from a slight scale
 *     for a "vape of smoke" entrance — slow enough that the transition
 *     reads as intentional rather than a flash.
 *   - Absolutely positioned inside a stacking-isolated page root
 *     (e.g. .ab-page / .bk-page / .bd-page with `isolation: isolate`)
 *     at z-index -1, so it sits behind all page content.
 */
export default function TopGradient() {
  return (
    <motion.div
      className="tg-root"
      initial={{ opacity: 0, scale: 1.04 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.9, ease: [0.22, 1, 0.36, 1] }}
      aria-hidden
    >
      <div className="tg-layer tg-layer-a" />
      <div className="tg-layer tg-layer-d" />
    </motion.div>
  );
}
